import React, { useCallback, useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Modal } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import debounce from "lodash.debounce";
import { User } from "../../types";
import useCredit from "../../hooks/useCredit";
import { roleTypes } from "../../constants";
import usercreditsService from "../../api/userService";
import Styles from '../../assets/styles/CreateDepartment.module.css'
import "./UserForm.css";
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Grid,
  Spacer,
  Text,
  useToast,
} from "@chakra-ui/react";
import { interceptorsSetup } from "../../api/intreceptor";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import MultiSelectStyle from '../../assets/styles/CreateDepartment.module.css'
import CreditContext from "../../contexts/creditProvider/creditContext";
import userService from "../../api/userService";
import { Select } from '@chakra-ui/react'

const UserForm = ({
  isCreateUser,
  isUpdateUser,
  userObj,
  modalHeader,
  closeModal,
  fetchUsers,
  useCreditPool,
  creditPoolBalance,
  setCreditPoolBalance,
  setToastMessage,
  setIsFeedActive,
  SetUserAfterUpdate,
  updatedUsersData,
  activeDepartments,
  totalAdmins,
  activeUserRole
}) => {
  const btnText = isCreateUser ? "Create" : "Update";
  const [currentUser, setCurrentUser] = useState<User>(userObj);
  const [credits, setCredits] = useState<number>(0);
  const [username, setUsername] = useState(userObj?.name || "");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [creditAction, setCreditAction] = useState("assign");
  const [enableUpdateUser, setEnableUpdateUser] = useState(false);
  const [submitButtonText, setSubmitButtonText] = useState(btnText);
  const [loading, setLoading] = useState(false);
  const [isEmailExits, setIsEmailExits] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const [allDeparts, setAllDepart] = useState([]);
  const [assignDepart, setAssignDepart] = useState([]);
  const [selected, setSelected] = useState([]);
  const {isCrditBalanceLoad} = useContext(CreditContext)
  const [passwordHide, setPasswordHide] = useState(false)
  const [isValidCredit, setIsValidCredit] = useState(false);
  const [validateEmailMsg, setValidateEmailMsg] = useState('');
  const [recurringEnabled, setRecurringEnabled] = useState(false);
  const [recurringAmount, setRecurringAmount] = useState("");
  const [recurringDay, setRecurringDay] = useState("1");
  const [recurringTouched, setRecurringTouched] = useState(false);
  const [hadExistingSchedule, setHadExistingSchedule] = useState(false);
  // const [loaderMessage, setLoaderMessage] = useState("Updating Users...")
  const { creditBalance, setCreditBalance } = useCredit();
	const comp_id = localStorage.getItem("comp_id")
	// The logged-in admin's own role (not `role` state above, which tracks
	// the EDITED user's role via the Role dropdown) - recurring top-up is a
	// standing, ongoing credit commitment (unlike the existing one-time
	// assign/revoke, which stays available to Admin) so it's restricted to
	// superAdmin only.
	const loggedInRole = localStorage.getItem("role")

  const handleCancel = () => {
    closeModal();
  };

  const departmentOptions = activeDepartments.map(department => ({
    label: `${department.department_name} (${department.department_code})`,
    value: department.id
  }));

  // Handle selection change
//   const handleSelectionChange = (selectedOptions) => {
//     setSelected(selectedOptions);
//   };

  // Single Select dropdown component
const handleSelectionChange = (event) => {
	const selectedValue = event.target.value;
	setSelected(selectedValue ? [{ label: event.target.selectedOptions[0].text, value: selectedValue }] : []);
  };

  // Get the selected IDs
  const department_id = selected.map(option => option.value);



  // console.log("multi select data;", activeDepartments)

  const changeCreditAction = (event) => {
    setCreditAction(event.target.value);
  };

  // Validating credit assigning and revoking
  const validateCreditAction = () => {
    let enable = true;
    if (
      creditAction === "assign" &&
      useCreditPool &&
      credits > creditPoolBalance
    ) {
      setError(
        `Credits assigned exceeds credit pool balance ${creditPoolBalance}`
      );
      setIsValidCredit(true)
      enable = false;
    }
    if (creditAction === "revoke" && credits > userObj?.credit_balance) {
      setError("Not enough balance to revoke");
      enable = false;
      setIsValidCredit(true)
    }
    return enable;
  };

  const isValidEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // validating update user form
  useEffect(() => {
    if (credits < 0) {
      setError("Credits cannot be less than 0");
      // setCredits(0);
      setEnableUpdateUser(false);
    } else if (
      credits == 0 &&
      (userObj?.role !== currentUser?.role || password || recurringTouched)
    ) {
      setEnableUpdateUser(true);
      setError("");
    } else if (credits == 0 && userObj?.role === currentUser?.role) {
      setEnableUpdateUser(false);
    } else if (credits > 0) {
      if (validateCreditAction()) {
        setEnableUpdateUser(true);
        setError(" ");
      } else {
        setEnableUpdateUser(false);
      }
    }

    if (isCreateUser) {
      if (!username) {
        // setError("Username is required");
        setEnableUpdateUser(false);
      } else {
        setError("");
        if (!isValidEmail(email)) {
          // setError("Invalid email");
          setEnableUpdateUser(false);
        } else {
          setError("");
          setEnableUpdateUser(true);
          if (!role) {
            // setError("Role is mandatory");
            setEnableUpdateUser(false);
          }
        }
      }
    }
  }, [
    currentUser,
    credits,
    creditAction,
    userObj,
    isCreateUser,
    username,
    email,
    role,
    recurringEnabled,
    recurringTouched,
  ]);

  useEffect(() => {
    interceptorsSetup(navigate);
  }, [navigate]);

  useEffect(() => {
    const preSelectedOptions = departmentOptions?.filter(option =>
      userObj?.department_id?.includes(option.value)
    );
    setSelected(preSelectedOptions || []);
  }, []);

  useEffect(() => {
    if (isUpdateUser && userObj?.email && loggedInRole === 'superAdmin') {
      userService.getRecurringTopup(userObj.email)
        .then((response) => {
          const schedule = response?.data?.schedule;
          const isActive = !!(schedule && schedule.is_active);
          if (isActive) {
            setRecurringEnabled(true);
            setRecurringAmount(String(schedule.amount));
            setRecurringDay(String(schedule.day_of_month));
          } else {
            setRecurringEnabled(false);
            setRecurringAmount("");
            setRecurringDay("1");
          }
          setHadExistingSchedule(isActive);
          setRecurringTouched(false);
        })
        .catch((err) => console.log("error while fetching recurring top-up schedule:", err));
    }
  }, [isUpdateUser, userObj?.email]);

  useEffect(() => {
    if (totalAdmins === 1 && role === "User" && activeUserRole==='Admin') {
      setError("Only one Admin left. Are you sure?");
    } else {
      setError("");
    }
  }, [role, totalAdmins, activeUserRole]);

  const syncRecurringTopup = () => {
    if (recurringEnabled) {
      const amount = Number(recurringAmount);
      const day_of_month = Number(recurringDay);
      if (!amount || amount <= 0 || !day_of_month) {
        return;
      }
      userService
        .setRecurringTopup({
          comp_id, email: currentUser.email, requested_by_email: localStorage.getItem("email"),
          amount, day_of_month,
        })
        .then(() => setHadExistingSchedule(true))
        .catch((err) => {
          console.log("error while saving recurring top-up schedule:", err);
          toast({
            title: "Failed to save recurring credit top-up schedule",
            position: "top",
            status: "warning",
            duration: 3000,
            variant: "left-accent",
            isClosable: true,
          });
        });
    } else if (hadExistingSchedule) {
      // Only worth a DELETE call if this user actually had an active
      // schedule to begin with - otherwise every ordinary user save (name/
      // role/department change, with recurring top-up left at its default
      // "off") would fire a pointless request for nothing to cancel.
      userService
        .deleteRecurringTopup({
          comp_id, email: currentUser.email, requested_by_email: localStorage.getItem("email"),
        })
        .then(() => setHadExistingSchedule(false))
        .catch((err) => console.log("error while cancelling recurring top-up schedule:", err));
    }
  };

  const updateUser = () => {
    if(isValidCredit){
      return (
        toast({
          title: `${error}`,
          position: "top",
          status: "warning",
          duration: 2000,
          variant: "left-accent",
          isClosable: true,
        })
      )
      
    }
    if(!(department_id.length > 0)){
     return(
      toast({
        title: `Department should not empty.`,
        position: "top",
        status: "warning",
        duration: 2000,
        variant: "left-accent",
        isClosable: true,
      })
     )
    }
    if (recurringEnabled && (!recurringAmount || Number(recurringAmount) <= 0)) {
      // syncRecurringTopup() silently no-ops on an invalid amount - block
      // the whole submit here instead, so the admin doesn't see a "User
      // Updated successfully" toast while the recurring schedule they
      // thought they just set was never actually saved.
      return (
        toast({
          title: `Recurring top-up amount must be greater than 0.`,
          position: "top",
          status: "warning",
          duration: 2000,
          variant: "left-accent",
          isClosable: true,
        })
      )
    }
    const options = {
      email: currentUser.email, // Include email field
      name: username,
      // id: currentUser.id || null,
      role: currentUser.role,
      password: password || null,
      // is_new_user: isCreateUser,
      transaction_amount: Number(credits),
      department_id:department_id,
	  comp_id:comp_id,
	  requested_by_email: localStorage.getItem("email"),
    };
    if (creditAction === "assign") {
      // options["CreditAssigned"] = Number(credits);
      options["transaction_type"] = 1; // transaction_type = 1 for credit assign
    } else {
      // options["Credit_Revoked"] = Number(credits);
      options["transaction_type"] = 2; // transaction_type = 2 for credit revoke
    }

    const user_info = JSON.stringify(options);

    setLoading(true);
    setSubmitButtonText(isCreateUser ? "Creating..." : "Updating...");
    setEnableUpdateUser(false);
    trackPromise(
      usercreditsService
        .updateUser(user_info)
        .then((response) => {
          if (response.status == 200) {
            const loggedEmail = localStorage.getItem("email");
            if(loggedEmail === response.data.new.email){
              setCreditBalance(response.data.new.balance)
            }
            const { users } = response.data;
            if (response.data.config) {
              // /user/updateuser doesn't always return a "config" block (only
              // /user/getusers does) - guard so a missing one doesn't throw
              // and abort the rest of this handler (credit pool refresh is a
              // nice-to-have here; fetchUsers() elsewhere is the source of truth).
              setCreditPoolBalance(response.data.config.credit_pool_balance)
            }
            toast({
              title: `${response.data.new.message}`,
              description: `${response.data.new.email}`,
              position: "top",
              status: "success",
              duration: 2000,
              variant: "left-accent",
              isClosable: true,
            });
            SetUserAfterUpdate(response.data.users);
            setSubmitButtonText(isCreateUser ? "Create" : "Update");
            setEnableUpdateUser(true);
            syncRecurringTopup();
          }

          setLoading(false);
          closeModal();
        })
        .catch((err) => {
          const { error } = err.response.data;
          setSubmitButtonText(isCreateUser ? "Create" : "Update");
          setEnableUpdateUser(true);
          setError(error);
          setLoading(false);
          setToastMessage("danger", error || "An error occured");
        })
    );
  };

  const validateEmail = async () => {
	setValidateEmailMsg("")
    try{
      setLoading(true)
      const res = await userService.validateEmail(email,comp_id);
		if(res.data.status == 1){
			createUser()
		}
		else{
			setValidateEmailMsg(res.data.message)
		}
    }catch(err){
      console.log("error:", err);
    }finally{
      setLoading(false);
    }
  }

  const createUser = async () => {
    const options = {
      email: email,
      name: username,
    //   password: password,
      role: role,
      credit_assigned: credits,
      department_id:department_id,
      comp_id: comp_id,
      requested_by_email: localStorage.getItem("email"),
    };
    if (
      !(
        username.length > 0 &&
        email.length > 0 &&
        role.length > 0 &&
        department_id.length > 0
      )
    ) {
      return toast({
        title: "Required fields are mandatory.",
        position: "top",
        status: "warning",
        duration: 2000,
        variant: "left-accent",
        isClosable: true,
      });
    }
    // if(isEmailExits.length > 0){
    //   return(
    //     toast({
    //           title: "Email is already exits.",
    //           position: "top",
    //           status: "warning",
    //           duration: 2000,
    //           variant: "left-accent",
    //           isClosable: true,
    //         })
    //   )
    // }

    const user_info = JSON.stringify(options);
    setSubmitButtonText(isCreateUser ? "Creating..." : "Updating...");

    try {
      setEnableUpdateUser(false);
      setLoading(true);
      const response = await usercreditsService.createUser(user_info);

      if (response.status == 200) {
        const { users } = response.data;
        toast({
          title: `${response?.data.new.message}`,
          description: `${response?.data.new.email}`,
          position: "top",
          status: "success",
          duration: 2000,
          variant: "left-accent",
          isClosable: true,
        });
        SetUserAfterUpdate(response.data.users);
      }
    } catch (err) {
      console.log("creating user err:", err);
      toast({
        title: `${err?.response?.data?.detail}`,
        position: "top",
        status: "warning",
        duration: 2000,
        variant: "left-accent",
        isClosable: true,
      });
      setEnableUpdateUser(true);
      setIsFeedActive(true);
    } finally {
      setLoading(false);
      setSubmitButtonText(isCreateUser ? "Create" : "Update");
      setEnableUpdateUser(true);
      closeModal();
    }
  };

  const setUserNameValue = (name) => {
    setUsername(name);
    setCurrentUser((prevUser) => ({
      ...prevUser,
      username: name,
    }));
  };

  const checkEmailExists = (email) => {
    return updatedUsersData.some((user) => user.email === email);
  };

  const debouncedCheckEmail = useCallback(
    debounce((email) => {
      if (checkEmailExists(email)) {
        setIsEmailExits("Email is already exists.");
      } else {
        setIsEmailExits("");
      }
    }, 1000),
    [updatedUsersData]
  );


  const setUserEmailValue = (email) => {
    // debouncedCheckEmail(email);
	setValidateEmailMsg("")
    setEmail(email);
    // setCurrentUser((prevUser) => ({
    //   ...prevUser,
    //   email: email,
    // }));
  };

  const setUserPasswordValue = (pwd) => {
    setPassword(pwd);
    setCurrentUser((prevUser) => ({
      ...prevUser,
      password: pwd,
    }));
  };

  const setUserRole = (e) => {
    setRole(e.target.value);
    setCurrentUser((prevUser) => ({
      ...prevUser,
      role: e.target.value,
    }));
  };

  const handleCreditsChange = (e) => {
    let value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
		if (value.startsWith('0') && value.length > 1 && !value.startsWith('0.')) {
		  value = value.replace(/^0+/, '');
		}
   
		setCredits(value);
	  }  
  };

  return (
    <div>
      <Modal
        size="lg"
        show={isCreateUser || isUpdateUser}
        onHide={closeModal}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="modal-header-text"
            id="example-modal-sizes-title-lg ps-10"
          >
            {isCreateUser ? "Create User" : "Update User"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Grid
            gridTemplateColumns={{ base: "repeat(1,1fr)", md: "repeat(2,1fr)" }}
            gap={{ base: "5px", md: "8px", lg: "10px" }}
          >
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label className="user-label">Name</Form.Label> {isCreateUser ? <span style={{color:"red"}}>*</span> : null} 
              <Form.Control
                className="user-input"
                type="text"
                name="username"
                value={username}
                onChange={(e) => setUserNameValue(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlInput2">
              <Form.Label className="user-label">Email</Form.Label>{isCreateUser ? <span style={{color:"red"}}>*</span> : null}
              {isCreateUser && (
                <Form.Control
                  className="user-input"
                  type="text"
                  name="email"
                  value={email || currentUser?.email}
                  onChange={(e) => setUserEmailValue(e.target.value)}
                  required
                />
              )}
              {isUpdateUser && (
                <Form.Control
                  className="user-input"
                  type="text"
                  name="email"
                  value={currentUser?.email}
                  disabled
                />
              )}
              {(isCreateUser && validateEmailMsg.length > 0 )&& (
                <Text color={"red"} mb={0} mt={"4px"} fontSize={"11px"}>
                  {/* {isEmailExits} */}
				{validateEmailMsg}
                </Text>
              )}
            </Form.Group>
            {!isCreateUser && <Form.Group controlId="exampleForm.ControlInput3">
              <Form.Label className="user-label">Password</Form.Label>{isCreateUser ? <span style={{color:"red"}}>*</span> : null}
              <Form.Control
                className="user-input"
                type={"password"}
                name="password"
                onChange={(e) => setUserPasswordValue(e.target.value)}
                required
              />
            </Form.Group>}
            <Form.Group controlId="exampleForm.ControlInput4">
              <Form.Label className="user-label">Role</Form.Label>{isCreateUser ? <span style={{color:"red"}}>*</span> : null}
              <Form.Select value={currentUser?.role} onChange={setUserRole}>
                <option value="">Select an option</option>
                {roleTypes.map((ele) => (
                  <option key={ele.name} value={ele.name}>
                    {ele.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {loggedInRole === 'superAdmin' && (
              <Form.Group controlId="exampleForm.ControlInput5">
                <Form.Label className="user-label">Credits</Form.Label>{isCreateUser ? <span style={{color:"red"}}>*</span> : null}
                <Form.Control
                  className="user-input"
                  type="text"
                  name="credit_revoked"
                  value={credits}
                  placeholder="e.g 1290"
                  // onChange={(e) => setCredits(Number(e.target.value))}
                  onChange={handleCreditsChange}
                  inputMode="decimal"
                  required
                />
              </Form.Group>
            )}
            <Form.Group controlId="exampleForm.ControlInput6">
              <Form.Label className="user-label">Department</Form.Label><span style={{color:"red"}}>*</span>
             {/* <MultiSelect
              options={departmentOptions}
              value={selected}
              onChange={handleSelectionChange}
              labelledBy="Select Departments"
              className={MultiSelectStyle.multi_selecet_input}
			  hasSelectAll={false}
             /> */}
			 <select
				value={selected[0]?.value || ''}
				onChange={handleSelectionChange}
				className={MultiSelectStyle.multi_selecet_input} style={{
					border: '1px solid #ccc'}}>
				<option value="" disabled>Select Department</option>
				{departmentOptions.map(option => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
				))}
  			</select>
            </Form.Group>
          </Grid>
          {loggedInRole === 'superAdmin' && (
            <div className="row">
              <label
                className="p-0"
                style={{ width: "70px", marginLeft: "10px" }}
              >
                <input
                  style={{ cursor: "pointer", marginRight: "2px" }}
                  type="radio"
                  value="assign"
                  checked={creditAction === "assign"}
                  onChange={changeCreditAction}
                />
                Assign
              </label>
              <label className="p-0" style={{ width: "70px" }}>
                <input
                  style={{ cursor: "pointer", marginRight: "2px" }}
                  type="radio"
                  value="revoke"
                  disabled={isCreateUser}
                  checked={creditAction === "revoke"}
                  onChange={changeCreditAction}
                />
                Revoke
              </label>
            </div>
          )}
          <div className="errorText">{error ? error : ""}</div>

          {isUpdateUser && loggedInRole === 'superAdmin' && (
            <Box mt={3} p={3} borderWidth="1px" borderRadius="5px">
              <label className="p-0" style={{ cursor: "pointer" }}>
                <input
                  style={{ cursor: "pointer", marginRight: "6px" }}
                  type="checkbox"
                  checked={recurringEnabled}
                  onChange={(e) => {
                    setRecurringEnabled(e.target.checked);
                    setRecurringTouched(true);
                  }}
                />
                Enable recurring monthly credit top-up
              </label>

              {recurringEnabled && (
                <Grid
                  gridTemplateColumns={{ base: "repeat(1,1fr)", md: "repeat(2,1fr)" }}
                  gap={{ base: "5px", md: "8px" }}
                  mt={2}
                >
                  <Form.Group>
                    <Form.Label className="user-label">Credit Amount</Form.Label>
                    <Form.Control
                      className="user-input"
                      type="text"
                      inputMode="decimal"
                      value={recurringAmount}
                      placeholder="e.g. 2500"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setRecurringAmount(value);
                          setRecurringTouched(true);
                        }
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="user-label">Day of Month</Form.Label>
                    <Form.Select
                      value={recurringDay}
                      onChange={(e) => {
                        setRecurringDay(e.target.value);
                        setRecurringTouched(true);
                      }}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Grid>
              )}
            </Box>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Flex alignItems={"center"} justifyContent={"flex-end"} gap={"15px"}>
            {isCreateUser ? (
              <Button
                id="btn"
                size={"sm"}
                disabled={loading || isEmailExits.length > 0}
                onClick={validateEmail}
              >
                {submitButtonText}
              </Button>
            ) : (
              <Button
                id="btn"
                size={"sm"}
                disabled={loading}
                onClick={updateUser}
              >
                {submitButtonText}
              </Button>
            )}
            <Button
              onClick={handleCancel}
              size={"sm"}
              colorScheme={"red"}
              variant={"outline"}
            >
              Close
            </Button>
          </Flex>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserForm;
